import { $ } from "../../../../helpers/dom-selectors.js";
import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async () => {
        const newIndex = APP_COMPONENTS.musicianForms.add();
        APP_COMPONENTS.fileForms.add(newIndex);
        APP_COMPONENTS.progressComponents.add(newIndex);
        const newFormObj = APP_COMPONENTS.musicianForms.getById(newIndex);
        if (!newFormObj)
            return;
        const { form } = newFormObj;
        const addInstrumentBtn = $(form, '.add-input-btn')[0];
        APP_COMPONENTS.addInstrumentBtn.addListener(addInstrumentBtn);
    }
};
